import { StyleSheet } from 'react-native'

const useStyles = (theme) => StyleSheet.create({
  loadingContainer: {
    position: 'absolute',
    backgroundColor: theme.WHITE,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 1,
    margin: 0
  }
})

export default useStyles
